import React, { createContext, useState, useEffect } from 'react';

export const ProductContext = createContext();

export const ProductProvider = ({ children }) => {
  const [products, setProducts] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    setLoading(true);
    fetch(`${process.env.REACT_APP_API_URL}/products?limit=1000`)
      .then(res => {
        if (!res.ok) {
          throw new Error(`HTTP error! status: ${res.status}`);
        }
        return res.json();
      })
      .then(data => {
        const productList = Array.isArray(data) ? data : (data.products || []);
        
        if (!Array.isArray(productList)) {
          console.error('ProductList no es un array:', productList);
          setProducts([]);
          return;
        }
        
        setProducts(productList);
        setError(null);
      })
      .catch(err => {
        console.error('Error al cargar productos:', err);
        setProducts([]);
        setError(err.message);
      })
      .finally(() => {
        setLoading(false);
      });
  }, []);

  return (
    <ProductContext.Provider value={{ products, setProducts, loading, error }}>
      {children}
    </ProductContext.Provider>
  );
};